export default "__VITE_ASSET__CjqFhj3g__"